import type React from 'react'

import { useEffect, useState } from 'react'
import { Tabs as TabsComponent, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

interface TabItem {
  value: string
  label: string
  content: React.ReactNode
  icon?: React.ReactNode
  disabled?: boolean
}

interface TabsComponentProps {
  defaultValue?: string
  tabs: TabItem[]
  className?: string
  onValueChange?: (value: string) => void
}

export function Tabs({ defaultValue, tabs, className, onValueChange }: TabsComponentProps) {
  const [activeTab, setActiveTab] = useState(defaultValue || tabs[0]?.value || '')

  // Update local state when defaultValue changes
  useEffect(() => {
    if (defaultValue) {
      setActiveTab(defaultValue)
    }
  }, [defaultValue])

  const handleTabChange = (value: string) => {
    setActiveTab(value)
    if (onValueChange) {
      onValueChange(value)
    }
  }

  return (
    <TabsComponent value={activeTab} defaultValue={activeTab} className={`w-full ${className || ''}`} onValueChange={handleTabChange}>
      <TabsList className={`flex bg-white border-b-2 rounded-b-none p-0 w-full flex-wrap justify-start h-auto align-top mb-2`}>
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            disabled={tab.disabled}
            className="text-slate-600 font-normal data-[state=active]:text-white rounded-none data-[state=active]:bg-primary data-[state=active]:border-b-2 data-[state=active]:border-b-primary flex gap-2 grow-0 p-2.5 data-[state=disabled]:opacity-50 data-[state=disabled]:cursor-not-allowed"
          >
            {tab.icon && <>{tab.icon}</>}
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {tabs.map((tab) => (
        <TabsContent key={tab.value} value={tab.value}>
          {tab.content}
        </TabsContent>
      ))}
    </TabsComponent>
  )
}
